const carouselItems = [
  {
    title: '暑期档悬疑剧王争霸',
    desc: '《暗夜追踪》《隐秘的角落》《白夜追凶》等高分悬疑剧同场竞技，谁才是你心中的悬疑之王？深度解析每部剧的烧脑程度与反转惊喜。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20mystery%20theme%20composition%2C%20silhouette%20of%20detective%20standing%20in%20foggy%20alley%2C%20dramatic%20shadows%20and%20neon%20highlights%2C%20film%20noir%20aesthetic%2C%20deep%20contrast%20with%20warm%20amber%20accents%2C%20professional%20movie%20poster%20design%2C%20suspenseful%20atmosphere&width=1200&height=500&seq=douhua-carousel-01&orientation=landscape',
    tag: '悬疑专题',
  },
  {
    title: '古装权谋大戏全解析',
    desc: '从《锦绣浮生》到《庆余年》，细数近年最值得追的古装权谋剧。精美服化道、烧脑剧情线、实力派演员阵容，带你走进波澜壮阔的古代世界。',
    img: 'https://readdy.ai/api/search-image?query=Epic%20ancient%20Chinese%20palace%20panorama%20with%20golden%20rooftops%20at%20sunset%2C%20dramatic%20clouds%2C%20traditional%20architecture%2C%20warm%20golden%20and%20crimson%20color%20scheme%2C%20cinematic%20wide%20shot%2C%20historical%20drama%20aesthetic%2C%20grand%20scale%20composition&width=1200&height=500&seq=douhua-carousel-02&orientation=landscape',
    tag: '古装专题',
  },
  {
    title: '国产动漫崛起之路',
    desc: '《灵笼》《凡人修仙传》《斗破苍穹》等国漫佳作盘点。从画面到剧情，国产动漫正在经历怎样的蜕变？哪些作品值得你入坑追更？',
    img: 'https://readdy.ai/api/search-image?query=Fantasy%20animation%20style%20landscape%20with%20floating%20temples%20and%20ancient%20mountains%2C%20vibrant%20dreamlike%20colors%2C%20epic%20scale%2C%20digital%20art%20illustration%2C%20cinematic%20lighting%20with%20warm%20golden%20accents%2C%20atmospheric%20mist%2C%20modern%20Chinese%20animation%20aesthetic&width=1200&height=500&seq=douhua-carousel-03&orientation=landscape',
    tag: '动漫专题',
  },
  {
    title: '纪录片里的真实世界',
    desc: '从BBC《地球脉动》到国产高分纪录片，真实影像的魅力无法替代。精选自然、人文、历史类纪录片片单，足不出户开阔视野。',
    img: 'https://readdy.ai/api/search-image?query=Breathtaking%20aerial%20view%20of%20African%20savanna%20with%20wildlife%20at%20golden%20hour%2C%20dramatic%20sunset%20sky%2C%20vast%20landscape%2C%20documentary%20cinematography%20style%2C%20warm%20amber%20and%20earthy%20tones%2C%20professional%20nature%20photography%2C%20epic%20scale&width=1200&height=500&seq=douhua-carousel-04&orientation=landscape',
    tag: '纪录片专题',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-extrabold text-foreground-950 mb-2">
          焦点大片
        </h2>
        <p className="text-sm text-foreground-500 mb-8 font-body">深度专题策划，带你发现更多精彩内容</p>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
          {carouselItems.map((item) => (
            <div
              key={item.title}
              className="group relative rounded-2xl overflow-hidden cursor-pointer"
            >
              <div className="w-full aspect-[24/10] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <span className="inline-block px-2.5 py-1 rounded-md bg-primary-500 text-background-50 text-xs font-semibold font-label mb-2">
                  {item.tag}
                </span>
                <h3 className="text-base md:text-lg font-heading font-bold text-background-50 mb-1.5">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-background-50/80 leading-relaxed font-body line-clamp-2 max-w-lg">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}